<template>
  <div>
    <div v-for="(id, index) in ids" :key="id">
      <h2 class="font-bold text-lg mb-1" :class="{ 'mt-2': index > 0 }">Production #{{ id }}</h2>
      <ProductionView :id="id" />
    </div>
  </div>
</template>

<script>
import ProductionView from '@/components/Templates/ProductionView'
import { computed } from '@vue/reactivity'
import { useRoute } from 'vue-router'

export default {
  components: {
    ProductionView,
  },
  setup() {
    const route = useRoute()
    const ids = computed(() => route.params.id.split(','))
    return { ids }
  },
}
</script>
